<div class="card mb-3">
  <div class="card-header">
    {{ 'shared.components.attachments_card.title' | translate }}
  </div>
  <div class="card-body">

    <ul class="list-group" >
      <li *ngFor="let at of formControl.value"
          class="list-group-item d-flex justify-content-between align-items-center">
        {{ at.name}}
        <div class="btn-group btn-group-sm">
          <button class="btn btn-sm btn-primary" (click)="openFile(at)" type="button" ><i class="fa fa-download"></i></button>
          <button class="btn btn-sm btn-danger" (click)="remove(at)" type="button" ><i class="fa fa-times"></i></button>
        </div>
      </li>

    </ul>

    <div class="mt-2 btn btn-secondary w-100" (click)="openModal()">
      {{ 'shared.components.attachments_card.button' | translate }}
    </div>
    <p class="mt-2 text-muted">
      {{ 'shared.components.attachments_card.warning_public' | translate }}
    </p>
  </div>
</div>



<ng-template #bsModalRefTemplateRef>

    <app-file-manager
      class="h-100"
      (filesSelected)="attachmentsSelected($event)"
      (requestClose)="modalRef?.hide()"
    >

    </app-file-manager>
</ng-template>
